<ng-container *ngIf="(canViewCompanySettings$ | async); else loadingTemplate">
  <ng-container *ngIf="availableWidgets$ | async; let availableWidgets">
    <ng-template [ngForOf]="getEntities(availableWidgets)" let-entity ngFor>
      <div *ngIf="!hiddenEntities.includes(entity)" class="row">
        <div class="col-12">
          <div class="card shadow">
            <app-help name="{{'settings.appearance.' + entity}}"></app-help>
            <div class="card-header card-header--padding">
              <div class="row">
                <div class="col text-left my-auto">
                  <p class="modal-title font-16 text-dark pt-2 pb-2">
                    <span>{{ ('settings.appearance.' + entity + '.widgets_title') | translate }}</span>
                  </p>
                </div>
                <div class="col-auto">
                  <button (click)="collapsedSettingSections[entity] = !collapsedSettingSections[entity]" *ngIf="collapsedSettingSections[entity] === false" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-up"></i></button>
                  <button (click)="collapsedSettingSections[entity] = !collapsedSettingSections[entity]" *ngIf="collapsedSettingSections[entity] === true" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-down"></i></button>
                </div>
              </div>
            </div>
            <div *ngIf="collapsedSettingSections[entity] === false" class="card-body">
              <div class="mb-3">
                <!-- Dashboard widgets order form -->
                <ng-container *ngIf="entity === 'dashboard'">
                  <div class="mb-2 py-2 heading-row">
                    <div class="row">
                      <div class="col-12">
                        <strong>{{ ('settings.appearance.' + entity + '.category_widgets_config') | translate }}</strong>
                      </div>
                    </div>
                  </div>
                  <div *ngFor="let widget of dashboardWidgetsForm; let isLast = last; let index = index" class="row">
                    <div class="col-12 py-2">
                      <div class="row">
                        <div class="py-0 pr-2 col">
                          <div>{{ ('settings.appearance.' + entity + '.' + widget.name) | translate }}</div>
                          <small class="text-muted">{{ ('settings.user_type_' + widget.user_type + '_description') | translate }}</small>
                          <div *ngIf="widget.name === 'employee_stats'"><u (click)="collapsedSettingSections['attendance_stats'] = false" class="text-muted" fragment="attendance_stats" routerLink="/setting/appearance">{{ 'settings.appearance.employee.category_setting' | translate }}</u></div>
                        </div>
                        <div class="col-auto">
                          <input (change)="onShowChange($event, widget)"
                                 [checked]="widget.show"
                                 [disabled]="widget.disabled && widget.name !== 'stopwatch'"
                                 [readOnly]="widget.disabled && widget.name !== 'stopwatch'"
                                 data-switch="success"
                                 id="{{ entity + '.' + widget.name }}"
                                 name="{{ entity + '.' + widget.name }}"
                                 type="checkbox"
                          >
                          <label [ngStyle]="{'opacity': (widget.disabled && widget.name !== 'stopwatch') ? 0.5 : 1}" class="m-0 mr-2" for="{{ entity + '.' + widget.name }}">&nbsp;</label>
                          <button (click)="moveUp(widget)" [disabled]="widget.disabled || index === 3" class="btn btn-icon btn-light mr-2"><i class="mdi mdi-menu-up"></i></button>
                          <button (click)="moveDown(widget)" [disabled]="widget.disabled || isLast" class="btn btn-icon btn-light"><i class="mdi mdi-menu-down"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngFor="let category of availableWidgets[entity] | keyvalue">
                  <ng-container *ngIf="!hiddenCategories.includes(category.key)">
                    <div class="mb-2 py-2 heading-row">
                      <div class="row">
                        <div class="col-12">
                          <strong>{{ ('settings.appearance.' + entity + '.category_' + category.key) | translate }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3 mt-2">
                      <ng-container *ngFor="let widget of category.value | keyvalue" class="">
                        <div *ngIf="!hiddenWidgets.includes(widget.key)" class="col-12 col-lg-6 col-xl-4 mb-2 mt-2 d-flex">
                          <div class="toggler">
                            <div class="d-flex w-100">
                              <div class="py-0 pr-2 w-100">
                                <span *ngIf="category.key !== 'custom_fields'">{{ ('settings.appearance.' + entity + '.' + widget.key) | translate }}</span>
                                <span *ngIf="category.key === 'custom_fields'">{{ widget.value.label }}</span>
                              </div>
                              <div class="flex-0">
                                <input (change)="changeWidgets(entity, category.key, (category.key === 'custom_fields' ? widget.value.custom_field_definition_ID : widget.key.toString()), $event)"
                                       [checked]="(category.key === 'custom_fields' ? widget.value.enabled : widget.value)"
                                       [disabled]="!(canEditCompanySettings$ | async)"
                                       [readOnly]="!(canEditCompanySettings$ | async)"
                                       data-switch="success"
                                       id="{{ entity + '.' + widget.key }}"
                                       name="{{ entity + '.' + widget.key }}"
                                       type="checkbox"
                                >
                                <label [ngStyle]="{'opacity': !(canEditCompanySettings$ | async) ? 0.5 : 1}" class="m-0" for="{{ entity + '.' + widget.key }}">&nbsp;</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
  
  <div class="row" id="attendance_stats">
    <div class="col-12">
      <div class="card shadow">
        <form (ngSubmit)="onSubmitAttendanceStats()" [formGroup]="attendanceStatsForm">
          <app-help name="{{'settings.appearance.attendance_stats'}}"></app-help>
          <div class="card-header card-header--padding">
            <div class="row">
              <div class="col text-left my-auto">
                <p class="modal-title font-16 text-dark pt-2 pb-2">
                  <span>{{ ('settings.appearance.attendance_stats.title') | translate }}</span>
                </p>
              </div>
              <div class="col-auto">
                <button (click)="collapsedSettingSections['attendance_stats'] = !collapsedSettingSections['attendance_stats']" *ngIf="collapsedSettingSections['attendance_stats'] === false" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-up"></i></button>
                <button (click)="collapsedSettingSections['attendance_stats'] = !collapsedSettingSections['attendance_stats']" *ngIf="collapsedSettingSections['attendance_stats'] === true" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-down"></i></button>
              </div>
            </div>
          </div>
          <div *ngIf="collapsedSettingSections['attendance_stats'] === false" class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">
                    <span>{{ 'settings.appearance.attendance_stats.placement' | translate }}</span>
                  </label>
                  
                  <ng-select
                      [clearable]="true"
                      [closeOnSelect]="false"
                      [multiple]="true"
                      class="custom"
                      formControlName="appearance.widgets.attendance_stats.placement"
                      name="appearance.widgets.attendance_stats.placement"
                  >
                    <ng-option *ngFor="let placement of attendanceStatsPlacements" [value]="placement">
                      <span>{{ ('settings.appearance.attendance_stats.placements.' + placement) | translate }}</span>
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            
            <div class="row mb-3">
              <div class="col-12 text-right">
                <small class="text-muted">
                  {{ 'settings.appearance.attendance_stats.placement_description' | translate }}
                </small>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">
                    <span>{{ 'settings.appearance.attendance_stats.datetime_types' | translate }}</span>
                  </label>
                  
                  <ng-select
                      [clearable]="true"
                      [closeOnSelect]="false"
                      [items]="datetimeTypes$ | async"
                      [multiple]="true"
                      bindLabel="name"
                      bindValue="employee_datetime_type_ID"
                      class="custom"
                      formControlName="appearance.widgets.attendance_stats.employee_datetime_type_IDs"
                      name="appearance.widgets.attendance_stats.employee_datetime_type_IDs"
                  >
                  </ng-select>
                </div>
              </div>
            </div>
            
            <div class="row mb-3">
              <div class="col-12 text-right">
                <small class="text-muted">
                  {{ 'settings.appearance.attendance_stats.datetime_types_description' | translate }}
                </small>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <label class="control-label"> {{ "settings.appearance.attendance_stats.show_weekly_stats" | translate }} </label>
                    </div>
                    <div class="col-auto">
                      <div>
                        <input
                            [id]="'show_weekly_stats'"
                            data-switch="success"
                            formControlName="appearance.widgets.attendance_stats.show_weekly_stats"
                            type="checkbox"
                        >
                        <label [for]="'show_weekly_stats'">&nbsp;</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <label class="control-label"> {{ "settings.appearance.attendance_stats.show_monthly_stats" | translate }} </label>
                    </div>
                    <div class="col-auto">
                      <div>
                        <input
                            [id]="'show_monthly_stats'"
                            data-switch="success"
                            formControlName="appearance.widgets.attendance_stats.show_monthly_stats"
                            type="checkbox"
                        >
                        <label [for]="'show_monthly_stats'">&nbsp;</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <label class="control-label"> {{ "settings.appearance.attendance_stats.show_days_in_company" | translate }} </label>
                    </div>
                    <div class="col-auto">
                      <div>
                        <input
                            [id]="'show_days_in_company'"
                            data-switch="success"
                            formControlName="appearance.widgets.attendance_stats.show_days_in_company"
                            type="checkbox"
                        >
                        <label [for]="'show_days_in_company'">&nbsp;</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row mt-2">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-success">
                  <span>{{ 'global.action_save' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <div class="row">
    <div class="col-12">
      <div class="card shadow">
        <form (ngSubmit)="onSubmitEmployeeTableDisplayMode()" [formGroup]="employeeTableDisplayModeForm">
          <app-help name="{{'settings.appearance.display_mode'}}"></app-help>
          <div class="card-header card-header--padding">
            <div class="row">
              <div class="col text-left my-auto">
                <p class="modal-title font-16 text-dark pt-2 pb-2">
                  <span>{{ ('settings.appearance.display_mode.title') | translate }}</span>
                </p>
              </div>
              <div class="col-auto">
                <button (click)="collapsedSettingSections['employee_table_display_mode'] = !collapsedSettingSections['employee_table_display_mode']" *ngIf="collapsedSettingSections['employee_table_display_mode'] === false" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-up"></i></button>
                <button (click)="collapsedSettingSections['employee_table_display_mode'] = !collapsedSettingSections['employee_table_display_mode']" *ngIf="collapsedSettingSections['employee_table_display_mode'] === true" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-down"></i></button>
              </div>
            </div>
          </div>
          <div *ngIf="collapsedSettingSections['employee_table_display_mode'] === false" class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">
                    <span>{{ 'settings.appearance.display_mode.employees_see' | translate }}</span>
                  </label>
                  
                  <ng-select
                      [clearable]="false"
                      class="custom"
                      formControlName="appearance.widgets.employee_table.settings.display_mode"
                      name="appearance.widgets.employee_table.settings.display_mode"
                  >
                    <ng-option *ngFor="let displayModeOption of displayModeOptionsEmployeeTable" [value]="displayModeOption">
                      <span>{{ 'settings.appearance.display_mode.' + displayModeOption | translate }}</span>
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            
            <div class="row mt-2">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-success">
                  <span>{{ 'global.action_save' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <div *ngIf="settings$ | async" class="row">
    <div class="col-12">
      <div class="card shadow">
        <form (ngSubmit)="onSubmitEventsTableDisplayMode()" [formGroup]="eventsTableDisplayModeForm">
          <app-help name="{{'settings.appearance.events_table_display_mode'}}"></app-help>
          <div class="card-header card-header--padding">
            <div class="row">
              <div class="col text-left my-auto">
                <p class="modal-title font-16 text-dark pt-2 pb-2">
                  <span>{{ ('settings.appearance.events_table_display_mode.title') | translate }}</span>
                </p>
              </div>
              <div class="col-auto">
                <button (click)="collapsedSettingSections['events_table_display_mode'] = !collapsedSettingSections['events_table_display_mode']" *ngIf="collapsedSettingSections['events_table_display_mode'] === false" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-up"></i></button>
                <button (click)="collapsedSettingSections['events_table_display_mode'] = !collapsedSettingSections['events_table_display_mode']" *ngIf="collapsedSettingSections['events_table_display_mode'] === true" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-down"></i></button>
              </div>
            </div>
          </div>
          <div *ngIf="collapsedSettingSections['events_table_display_mode'] === false" class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label">
                    <span>{{ 'settings.appearance.events_table_display_mode.employees_see' | translate }}</span>
                  </label>
                  
                  <ng-select
                      [clearable]="false"
                      class="custom"
                      formControlName="company.events.display_mode"
                      name="company.events.display_mode"
                  >
                    <ng-option *ngFor="let displayModeOption of displayModeOptionsEventsTable" [value]="displayModeOption">
                      <span>{{ 'settings.appearance.events_table_display_mode.' + displayModeOption | translate }}</span>
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            
            <fieldset class="fieldset-bordered py-2">
              <legend>{{ 'settings.appearance.events_table_display_mode.full' | translate }}</legend>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'settings.appearance.events_table_display_mode.full_types' | translate }}</span>
                    </label>
                    
                    <ng-select
                        [clearable]="false"
                        [closeOnSelect]="false"
                        [items]="eventTypes$ | async"
                        [multiple]="true"
                        bindLabel="label"
                        bindValue="value"
                        class="custom"
                        formControlName="company.events.full_types"
                        name="company.events.full_types"
                    >
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'settings.appearance.events_table_display_mode.full_roles' | translate }}</span>
                    </label>
                    
                    <ng-select
                        [clearable]="false"
                        [closeOnSelect]="false"
                        [items]="roles$ | async"
                        [multiple]="true"
                        bindLabel="name"
                        bindValue="role_ID"
                        class="custom"
                        formControlName="company.events.full_roles"
                        name="company.events.full_roles"
                    >
                    </ng-select>
                  </div>
                </div>
                <div class="col-12 text-right">
                  <small class="text-muted">{{ 'settings.appearance.events_table_display_mode.full_description' | translate }}</small>
                </div>
              </div>
            </fieldset>
            
            <fieldset class="fieldset-bordered py-2">
              <legend>{{ 'settings.appearance.events_table_display_mode.simple' | translate }}</legend>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'settings.appearance.events_table_display_mode.simple_types' | translate }}</span>
                    </label>
                    
                    <ng-select
                        [clearable]="false"
                        [closeOnSelect]="false"
                        [items]="eventTypesEmployee$ | async"
                        [multiple]="true"
                        bindLabel="label"
                        bindValue="value"
                        class="custom"
                        formControlName="company.events.simple_types"
                        name="company.events.simple_types"
                    >
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'settings.appearance.events_table_display_mode.simple_roles' | translate }}</span>
                    </label>
                    
                    <ng-select
                        [clearable]="false"
                        [closeOnSelect]="false"
                        [items]="roles$ | async"
                        [multiple]="true"
                        bindLabel="name"
                        bindValue="role_ID"
                        class="custom"
                        formControlName="company.events.simple_roles"
                        name="company.events.simple_roles"
                    >
                    </ng-select>
                  </div>
                </div>
                <div class="col-12 text-right">
                  <small class="text-muted">{{ 'settings.appearance.events_table_display_mode.simple_description' | translate }}</small>
                </div>
              </div>
            </fieldset>
            
            <div class="row">
              <div class="col-12 text-right">
                <small class="text-muted">{{ 'settings.appearance.events_table_display_mode.description' | translate }}</small>
              </div>
            </div>
            
            <div class="row mt-2">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-success">
                  <span>{{ 'global.action_save' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <div *ngIf="settings$ | async" class="row">
    <div class="col-12">
      <div class="card shadow">
        <form (ngSubmit)="onSubmitBusinessPartners()" [formGroup]="businessPartnersForm">
          <app-help name="{{'settings.appearance.business_partner'}}"></app-help>
          <div class="card-header py-3">
            <div class="row">
              <div class="col text-left my-auto">
                <p class="modal-title font-16 text-dark pt-2 pb-2">
                  <span>{{ ('settings.appearance.business_partner.title') | translate }}</span>
                </p>
              </div>
              <div class="col-auto">
                <button (click)="collapsedSettingSections['business_partner'] = !collapsedSettingSections['business_partner']" *ngIf="collapsedSettingSections['business_partner'] === false" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-up"></i></button>
                <button (click)="collapsedSettingSections['business_partner'] = !collapsedSettingSections['business_partner']" *ngIf="collapsedSettingSections['business_partner'] === true" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-down"></i></button>
              </div>
            </div>
          </div>
          <div *ngIf="collapsedSettingSections['business_partner'] === false" class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <label class="control-label"> {{ "settings.appearance.business_partner.enabled" | translate }} </label>
                    </div>
                    <div class="col-auto">
                      <div>
                        <input
                            [id]="'business_partner'"
                            data-switch="success"
                            formControlName="appearance.company_groups.business_partner"
                            type="checkbox"
                        >
                        <label [for]="'business_partner'">&nbsp;</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row mt-2">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-success">
                  <span>{{ 'global.action_save' | translate }}</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <div *ngIf="settings$ | async" class="row">
    <div class="col-12">
      <div class="card shadow">
        <app-help name="{{'settings.appearance.questionnaire'}}"></app-help>
        <div class="card-header card-header--padding">
          <div class="row">
            <div class="col text-left my-auto">
              <p class="modal-title font-16 text-dark pt-2 pb-2">
                <span>{{ ('settings.appearance.questionnaire.title') | translate }}</span>
              </p>
            </div>
            <div class="col-auto">
              <button (click)="collapsedSettingSections['questionnaire'] = !collapsedSettingSections['questionnaire']" *ngIf="collapsedSettingSections['questionnaire'] === false" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-up"></i></button>
              <button (click)="collapsedSettingSections['questionnaire'] = !collapsedSettingSections['questionnaire']" *ngIf="collapsedSettingSections['questionnaire'] === true" class="btn btn-icon btn-light mr-1"><i class="mdi mdi-menu-down"></i></button>
            </div>
          </div>
        </div>
        <div *ngIf="collapsedSettingSections['questionnaire'] === false" class="card-body">
          <form
              (ngSubmit)="onSubmitQustionnaire()"
              [formGroup]="questionnaireForm"
              autocomplete="off"
          >
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="control-label">
                    <span>{{ 'settings.appearance.questionnaire.identify_company_by' | translate }}</span>
                  </label>
                  
                  <ng-select
                      [closeOnSelect]="true"
                      [multiple]="false"
                      class="custom"
                      formControlName="appearance.questionnaire.identify_company_by"
                  >
                    <ng-option [value]="'COMPANY'">{{ 'settings.appearance.questionnaire.option_COMPANY' | translate }}</ng-option>
                    <ng-option [value]="'COMPANY_BRANCH'">{{ 'settings.appearance.questionnaire.option_COMPANY_BRANCH' | translate }}</ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-6">
                <label class="control-label mb-0">
                  <span>{{ 'settings.appearance.questionnaire.introduction_text_settings' | translate }}</span>
                </label>
              </div>
              
              <div class="col-6 text-right align-self-center">
                <div>
                  <input
                      data-switch="success"
                      formControlName="appearance.questionnaire.show_introduction_text"
                      id="appearance.questionnaire.show_introduction_text"
                      name="appearance.questionnaire.show_introduction_text"
                      type="checkbox"
                  >
                  
                  <label for="appearance.questionnaire.show_introduction_text">&nbsp;</label>
                </div>
              </div>
            </div>
            
            <div [(ngbCollapse)]="!questionnaireForm.value['appearance.questionnaire.show_introduction_text']">
              <div class="row">
                <div class="col-12 text-right">
                  <small class="text-muted">{{ 'settings.appearance.questionnaire.settings_introduction_text_explanation' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="control-label">{{ 'settings.appearance.questionnaire.introduction_text' | translate }}</label>
                    <input [ngxSummernote]="summernoteHelper.getSummernoteConfig()"
                           class="form-control"
                           formControlName="appearance.questionnaire.introduction_text"
                           name="company.appearance.questionnaire.introduction_text"
                           type="text">
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row mt-2">
              <div class="col-6">
                <label class="control-label mb-0">
                  <span>{{ 'settings.appearance.questionnaire.ending_text_settings' | translate }}</span>
                </label>
              </div>
              
              <div class="col-6 text-right align-self-center">
                <div>
                  <input
                      data-switch="success"
                      formControlName="appearance.questionnaire.show_ending_text"
                      id="appearance.questionnaire.show_ending_text"
                      name="appearance.questionnaire.show_ending_text"
                      type="checkbox"
                  >
                  
                  <label for="appearance.questionnaire.show_ending_text">&nbsp;</label>
                </div>
              </div>
            </div>
            
            <div [(ngbCollapse)]="!questionnaireForm.value['appearance.questionnaire.show_ending_text']">
              <div class="row">
                <div class="col-12 text-right">
                  <small class="text-muted">{{ 'settings.appearance.questionnaire.settings_ending_text_explanation' | translate }}</small>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="control-label">{{ 'settings.appearance.questionnaire.ending_text' | translate }}</label>
                    <input [ngxSummernote]="summernoteHelper.getSummernoteConfig()"
                           class="form-control"
                           formControlName="appearance.questionnaire.ending_text"
                           name="company.appearance.questionnaire.ending_text"
                           type="text">
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row mt-2">
              <div class="col d-flex justify-content-end">
                <button class="btn btn-success">
                  <span>{{ 'global.action_save' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  
  <app-widget-templates-list [definitions]="customFieldDefinitions"></app-widget-templates-list>
  
  <app-custom-field-list (setDefinitions)="setCustomFieldDefinitions($event)"></app-custom-field-list>
  
  <app-setting-menu></app-setting-menu>
</ng-container>

<ng-template #loadingTemplate>
  <div class="card shadow p-3 mb-3">
    <div class="item">
      <ngx-skeleton-loader [theme]="{
      'margin': '15px 0'
    }" appearance="line" count="8"></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>
